<template>
  <div class="content-container">
    <!-- Search Component -->
    <!-- <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col w-25">
            <div class="das-form-input">
              <div class="label">Giao dịch phụ</div>
              <div class="child-w-80">
                <input type="text" placeholder="Nhập thông tin giao dịch phụ">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <SubTransactionSearch /> -->
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        :rows="rows"
        dom-layout="scroll"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="onSelectionChange"
      />
    </div>
    <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->
    <div class="button-containers mb-0">
      <button
        :disabled="selectedRows.length === 0"
        class="btn primary small outline"
        @click="deleteSubTransaction"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="selectedRows.length !== 1"
        class="btn primary small"
        @click="editSubTransactionType"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button type="primary" @click="dialogFormVisible = true">
        Thêm giao dịch phụ
      </el-button>
      <el-button type="danger" @click="deleteSubTransaction">
        Xóa giao dịch phụ
      </el-button>
    </el-col> -->
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.subTransactionTypeUpdate')
          : $t('dialog.subTransactionTypeAdd')
      "
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Loại giao dịch">
                  <div class="das-form-input">
                    <div class="label required">Loại giao dịch:</div>
                    <el-select
                      v-model="subTransactionTypeItem.transaction_type_id"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in transactionType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <!-- <select-with-search-table
                      style="width: 100%"
                      :rows="transactionType"
                      :columns="selectSearchCol1"
                      :value="subTransactionTypeItem.transaction_type_id"
                      :selected-index-field-value="
                        subTransactionTypeItem.transaction_type_id
                      "
                      index-field="id"
                      @selectionChanged="onSelectRowOption1"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.desc }}
                      </template>
                    </select-with-search-table> -->
                    <!-- <div class="child-w-80">
                      <select
                        v-model="subTransactionTypeItem.transaction_type_id"
                      >
                        <option
                          v-for="item in transactionType"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.desc }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max: 100"
                  name="Loại giao dịch phụ"
                >
                  <div class="das-form-input">
                    <div class="label required">Loại giao dịch phụ:</div>
                    <div class="child-w-80">
                      <input
                        v-model="subTransactionTypeItem.name"
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Thứ tự:</div>
                  <div class="child-w-80">
                    <input v-model="subTransactionTypeItem.order" type="text">
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </validation-observer>
      <!-- <el-form>
        <el-form-item label="Loại giao dịch">
          <el-select ref="select" v-model="subTransactionTypeItem.transaction_type">
            <el-option v-for="item in transactionType" :key="item.transaction_type_id" :label="item.name" :value="item.transaction_type_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Loại giao dịch phụ">
          <el-input
            v-model="subTransactionTypeItem.name"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
        <el-form-item label="Thứ tự">
          <el-input v-model="subTransactionTypeItem.order" placeholder="Nhập thông tin" />
        </el-form-item>
      </el-form> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateSubTransaction"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small"
            @click="addSubTransactionType"
          >
            {{ $t('button.create') }}
          </button>
        </div>
        <!-- <el-button @click="dialogFormVisible = false">Huỷ</el-button>
        <el-button
          v-if="isEdit"
          type="primary"
          @click="updateSubTransaction"
        >Cập nhật</el-button>
        <el-button
          v-else
          type="primary"
          @click="addSubTransactionType"
        >Tạo mới</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

// import { getListSubTransactionApi, addSubTransactionApi, updateSubTransactionApi,deleteSubTransactionApi} from '@/api/configuration/accounting/subTransaction.js'
import {
  getListSubTransactionTypeApi,
  addSubTransactionTypeApi,
  updateSubTransactionTypeApi,
  deleteSubTransactionTypeApi
} from '@/api/configuration/accounting/subTransactionType.js'
import { Message } from 'element-ui'
import SubTransactionSearch from './components/subTransactionSearch.vue'
import { transactionDat } from '../subTransaction/components/data'
export default {
  components: {
    SubTransactionSearch
  },
  data() {
    return {
      selectedRows: [],
      selectSearchCol1: [
        {
          headerName: 'Loại giao dịch',
          field: 'label',
          flex: 1
        }
      ],
      loading: false,
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      buildingItem: {
        building_no: '',
        name: '',
        id: null
      },
      subTransactionTypeItem: {
        transaction_type_id: null,
        name: null
        // order: ''
      },
      transactionType: [],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Loại giao dịch phụ',
          field: 'name',
          tooltipField: 'name',
          width: 100
        },
        {
          headerName: 'Loại giao dịch',
          field: 'transaction_type_name',
          tooltipField: 'transaction_type_name'
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetSubTransactionTypeInfo()
    }
  },

  mounted() {
    this.attachData()
    this.getTransactionType()
  },
  methods: {
    onSelectionChange(rows) {
      this.selectedRows = rows
    },
    onSelectRowOption1(val) {
      this.subTransactionTypeItem.transaction_type_id = val.value
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    getTransactionType() {
      Object.assign(this.transactionType, transactionDat)
      // this.$axios
      //   .get('/config-service/v1/statistic/code?pCode=TRANSACTION_TP')
      //   .then(res => {
      //     this.transactionType = res.data
      //   })
      //   .catch(error => console.log(error))
    },
    async attachData() {
      this.loading = true
      let data = await getListSubTransactionTypeApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
      //
      this.selectedRows = []
    },
    async addSubTransactionType() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addSubTransactionTypeApi(this.subTransactionTypeItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateSubTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateSubTransactionTypeApi(this.subTransactionTypeItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteSubTransaction() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      } else {
        this.$vxConfirm(this.$t('alert.deleteSubTransactionConfirm'), () => {
          deleteSubTransactionTypeApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },

    editSubTransactionType() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.titlePopup = 'Sửa loại giao dịch phụ'
      this.isEdit = true
      Object.assign(this.subTransactionTypeItem, row)
      this.dialogFormVisible = true
    },
    resetSubTransactionTypeInfo() {
      this.isEdit = false
      this.subTransactionTypeItem.transaction_type_id = null
      this.subTransactionTypeItem.name = null
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
